import { render, staticRenderFns } from "./PromotionSimple.vue?vue&type=template&id=330e86de&scoped=true"
import script from "./PromotionSimple.vue?vue&type=script&lang=js"
export * from "./PromotionSimple.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PromotionSimple.vue?vue&type=style&index=1&id=330e86de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e86de",
  null
  
)

export default component.exports